export const createAchievementsRequests = (client) => ({
    listAchievements: async (params) => {
        const { data, meta, links } = await client.api.get("achievements", {
            params: params,
        });
        return { data, meta, links };
    },
    findAchievement: async (params) => {
        const { data } = await client.api.get(`achievements/${params?.filter?.id}`, {
            params: params,
        });
        return { data };
    },
});
//# sourceMappingURL=index.js.map